import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import dt from '../../../shared/theme';
import wirePropType from './prop-types';
import Ul from './common-styles';
import Embed from './embed';
import { clickToShare, socialMedia } from '../../../shared/click-to-share';

const Ulist = styled.ul`
  ${Ul};

  li {
    a {
      span {
        font-size: 18px;
      }
    }

    h3 {
      font-size: 12px;
      color: ${props => dt(props).theme.bodyColor};
    }
  }
`;

const buildClickHandler = (d, wire) => () => clickToShare({
  wireId: wire.id,
  source: _.toLower(d),
  medium: 'wire-page-share',
});

const buildProps = (d, wire) => ({
  'data-statisticable-event': 'click',
  'data-statisticable-type': 'wire',
  'data-statisticable-event-type': _.snakeCase(`${d}Share`),
  'data-statisticable-id': wire.id,
  className: `icon-lw icon-lw-${d.replace('_', '').toLowerCase()}`,
});

export default function ShareGroup({ wire }) {
  return (
    <Ulist className="--share">
      <li><h3>Share</h3></li>
      <li><Embed wire={wire} /></li>
      <li>
        <a href={wire.shares.email} title="Share this wire with an email">
          <span className="icon-lw icon-lw-email" />
        </a>
      </li>
      {socialMedia.map(d => (
        <li key={d}>
          <a href="#" title={`Share this wire on ${d.replace('_', '')}`} onClick={buildClickHandler(d, wire)}>
            <span {...buildProps(d, wire)} />
          </a>
        </li>
      ))}
    </Ulist>
  );
}

ShareGroup.propTypes = wirePropType;
